import * as Yup from "yup";

import { VALIDATION_TYPES } from "@/components/Formik";

export const PAYMENT_NAMES = {
  BANKGIRO: "Bankgiro",
  PLUSGIRO: "PlusGiro",
  DOMESTIC_BANKACCOUNT_TRANSACTION: "Domestic Bankaccount Transaction",
  INTERNATIONAL_BANKING_DETAILS: "International Banking Details",
};

const bankDetailSchema = Yup.object()
  .shape({
    status: Yup.string().oneOf(["ACTIVE", "INACTIVE"]).required(),

    paymentName: Yup.string().when("status", {
      is: "ACTIVE",
      then: Yup.string().required(VALIDATION_TYPES.REQUIRED).typeError(VALIDATION_TYPES.REQUIRED),
      otherwise: Yup.string().notRequired(),
    }),

    bankNumber: Yup.string().when(["paymentName", "status"], {
      is: (paymentName: string, status: string) => paymentName === PAYMENT_NAMES.BANKGIRO && status === "ACTIVE",
      then: Yup.string()
        .required(VALIDATION_TYPES.REQUIRED)
        .matches(/^\d{3}-\d{4}$|^\d{4}-\d{4}$/, VALIDATION_TYPES.BANKGIRO),
      otherwise: Yup.string().when(["paymentName", "status"], {
        is: (paymentName: string, status: string) => paymentName === PAYMENT_NAMES.PLUSGIRO && status === "ACTIVE",
        then: Yup.string()
          .required(VALIDATION_TYPES.REQUIRED)
          .matches(
            /^\d{1,2}-\d$|^\d{2}-\d$|^\d{3}-\d$|^\d{4}-\d$|^\d{5}-\d$|^\d{6}-\d$|^\d{7}-\d$/,
            VALIDATION_TYPES.PLUSGIRO,
          ),
        otherwise: Yup.string().when(["paymentName", "status"], {
          is: (paymentName: string, status: string) =>
            paymentName === PAYMENT_NAMES.DOMESTIC_BANKACCOUNT_TRANSACTION && status === "ACTIVE",
          then: Yup.string().required(VALIDATION_TYPES.REQUIRED),
          otherwise: Yup.string().notRequired(),
        }),
      }),
    }),

    iban: Yup.string().when(["paymentName", "status"], {
      is: (paymentName: string, status: string) =>
        paymentName === PAYMENT_NAMES.INTERNATIONAL_BANKING_DETAILS && status === "ACTIVE",
      then: Yup.string()
        .required(VALIDATION_TYPES.REQUIRED)
        .matches(/^[A-Za-z0-9]{1,34}$/, VALIDATION_TYPES.IBAN),
      otherwise: Yup.string().notRequired(),
    }),

    swift: Yup.string().when(["paymentName", "status"], {
      is: (paymentName: string, status: string) =>
        paymentName === PAYMENT_NAMES.INTERNATIONAL_BANKING_DETAILS && status === "ACTIVE",
      then: Yup.string()
        .required(VALIDATION_TYPES.REQUIRED)
        .matches(/^[A-Za-z0-9]{8,11}$/, VALIDATION_TYPES.SWIFT),
      otherwise: Yup.string().notRequired(),
    }),

    countryCode: Yup.string().when("status", {
      is: "ACTIVE",
      then: Yup.string().required(VALIDATION_TYPES.REQUIRED),
      otherwise: Yup.string().notRequired(),
    }),

    isFactoringCompany: Yup.boolean().optional(),
    primary: Yup.boolean().required(VALIDATION_TYPES.REQUIRED),
  })
  .required(VALIDATION_TYPES.REQUIRED);

export const bankingDetailsSchema = Yup.object().shape({
  bankingDetails: Yup.array()
    .of(bankDetailSchema)
    .test("one-primary", VALIDATION_TYPES.PRIMARY, value => {
      const activeItems = value?.filter(item => item.status === "ACTIVE") || [];
      return activeItems.length === 0 || activeItems.filter(item => item.primary)?.length === 1;
    })
    .required(VALIDATION_TYPES.REQUIRED),
});
